var selectedScheme = 'navigation-left';

var colourClasses = "theme-default theme-navy theme-blue theme-green theme-brown theme-red theme-pink theme-purple";
var headingClasses = "headings-arial headings-open-sans headings-roboto headings-nunito-sans headings-fira-sans headings-merriweather";
var bodyClasses = "body-arial body-open-sans body-roboto body-nunito-sans body-fira-sans body-merriweather";

$('.demo-close').click(function(){
    $('.demo-panel').toggleClass('demo-panel-close');
});

$('.btn-theme-default').click(function(){
    $('body').removeClass(colourClasses)
});

$('.btn-theme-navy').click(function(){
    $('body').removeClass(colourClasses).addClass('theme-navy');
});

$('.btn-theme-blue').click(function(){
    $('body').removeClass(colourClasses).addClass('theme-blue');
});

$('.btn-theme-green').click(function(){
    $('body').removeClass(colourClasses).addClass('theme-green');
});

$('.btn-theme-brown').click(function(){
    $('body').removeClass(colourClasses).addClass('theme-brown');
});

$('.btn-theme-red').click(function(){
    $('body').removeClass(colourClasses).addClass('theme-red');
});

$('.btn-theme-pink').click(function(){
    $('body').removeClass(colourClasses).addClass('theme-pink');
});

$('.btn-theme-purple').click(function(){
    $('body').removeClass(colourClasses).addClass('theme-purple');
});

$('#font_family_heading').change(function(){
    $('body').removeClass(headingClasses).addClass('headings-' + $(this).val());
});

$('#font_family_body').change(function(){
    $('body').removeClass(bodyClasses).addClass('body-' + $(this).val());
});

